<template>
    <module-card :nextDisabled="nextDisabled">
        <p>Confirm your cell number and email address.</p>
        <p>Don’t worry, we won’t be sharing these!</p>
        <v-text-field outlined label="Cell" type="tel" v-mask="'(###) ###-####'" v-model="phone"></v-text-field>
        <v-text-field outlined label="Email" type="email" v-model="email"></v-text-field>
    </module-card>
</template>

<script>
    import { sync } from 'vuex-pathify';
    import isEmail from 'validator/lib/isEmail';

    export default {
        computed: {
            phone: sync('phone'),
            email: sync('email')
        },
        methods: {
            nextDisabled() {
                return !this.phone || this.phone.length < 14 || !this.email || !isEmail(this.email);
            }
        }
    };
</script>
